import ApiService from "../Services/ApiService";

/**
 * P4 – Description générique du déroulé habituel des séances.
 */
export interface SessionDescriptionInfo {
    id: number;
    description: string;
    subjectId: number | null;
    createdAt: string | null;
    updatedAt: string | null;
}

export const SESSION_DESCRIPTION_MIN_LENGTH = 30;
export const SESSION_DESCRIPTION_MAX_LENGTH = 1000;

export default abstract class SessionDescriptionRepository {
    /** Description globale du professeur, ou null si elle n'existe pas encore. */
    public static get(teachrId: number): Promise<{ sessionDescription: SessionDescriptionInfo | null }> {
        return ApiService.get(`/teachrs/v2/teachrs/${teachrId}/session-description`) as Promise<{ sessionDescription: SessionDescriptionInfo | null }>;
    }

    /** Crée ou met à jour la description globale du professeur. */
    public static save(teachrId: number, description: string): Promise<{ sessionDescription: SessionDescriptionInfo }> {
        return ApiService.put(`/teachrs/v2/teachrs/${teachrId}/session-description`, { description } as any) as Promise<{ sessionDescription: SessionDescriptionInfo }>;
    }
}
